export default __webpack_public_path__ + "static/patio-v4-2-b61961f4f698e8df9e76acb92a7050f1.jpg";